import { useState } from 'react';
import { authApi } from '../lib/authApi';
import { ApiError } from '../lib/api';
import { useAuth } from './AuthContext';
import { AuthError, AuthScreen } from './AuthScreen';

/**
 * First-run wizard: shown exactly once, when the user store is empty. What it
 * creates becomes the one super admin and inherits every organisation that
 * existed before accounts did, so nothing pre-existing ends up ownerless.
 */
export function BootstrapAdminForm() {
  const { refresh } = useAuth();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password !== confirm) {
      setError('Пароли не совпадают');
      return;
    }
    if (password.length < 8) {
      setError('Пароль должен быть не короче 8 символов');
      return;
    }
    setBusy(true);
    setError(null);
    try {
      await authApi.bootstrap({ email, password, name });
      await refresh();
    } catch (e) {
      setError(
        e instanceof ApiError
          ? 'Не удалось создать администратора. Проверьте почту и пароль.'
          : 'Сервер недоступен. Проверьте, что запущены оба процесса — web и server.',
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthScreen
      title="Настройка Ygrik Board"
      subtitle="Это первый запуск — создайте аккаунт администратора. Он получит доступ ко всем организациям и админ-панели."
    >
      <form className="auth-form" onSubmit={submit}>
        <label className="auth-field">
          <span>Имя</span>
          <input
            type="text"
            autoFocus
            required
            maxLength={60}
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Как к вам обращаться"
          />
        </label>
        <label className="auth-field">
          <span>Почта</span>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
          />
        </label>
        <label className="auth-field">
          <span>Пароль</span>
          <input
            type="password"
            required
            minLength={8}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Не короче 8 символов"
          />
        </label>
        <label className="auth-field">
          <span>Повторите пароль</span>
          <input
            type="password"
            required
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
          />
        </label>

        <AuthError message={error} />

        <button type="submit" className="primary-btn auth-submit" disabled={busy}>
          {busy ? 'Создание…' : 'Создать администратора'}
        </button>
      </form>
    </AuthScreen>
  );
}
